import React from 'react';
import { leadStatusColors, neutralColors } from '../../styles/colors';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info' | 'purple' | 'blue-pastel' | 'yellow-pastel' | 'red-dark-pastel' | 'red-light-pastel' | 'orange-pastel' | 'violet-pastel' | 'green-dark-pastel';
  size?: 'sm' | 'md';
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ 
  children, 
  variant = 'default', 
  size = 'md', 
  className = '' 
}) => {
  const baseClasses = 'inline-flex items-center font-medium rounded-full';
  
  const variantClasses = {
    default: neutralColors.default,
    success: leadStatusColors.completed,
    warning: leadStatusColors.pending,
    danger: leadStatusColors.rejected,
    info: leadStatusColors.to_contact,
    purple: leadStatusColors.in_production,
// Pastel colors for statuses - with modern effects
    'blue-pastel': leadStatusColors.to_contact,
    'yellow-pastel': leadStatusColors.pending,
    'red-dark-pastel': leadStatusColors.rejected,
    'red-light-pastel': leadStatusColors.abandoned,
    'orange-pastel': leadStatusColors.negotiation,
    'violet-pastel': leadStatusColors.in_production,
    'green-dark-pastel': leadStatusColors.completed,
  };
  
  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1 text-sm',
  };
  
  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;

  return (
    <span className={classes}>
      {children}
    </span>
  );
};

export default Badge;
